
import Transformer from './../../transformer'
import SupplyTransformer from './../supplys/supply'

export default class RoadConceptJBSupplyTransformer extends Transformer {
	static fetch(jbSupply) {
		const supply = SupplyTransformer.fetch(jbSupply.supply)

		return {
			id: jbSupply.id,
			supplyId: supply.id,
			quantity: +jbSupply.quantity,
			roadConceptJB: jbSupply.road_concept_jb,
			comment: jbSupply.comment,
			supply, 
      supplyName: supply.name,
      code: jbSupply.supply.code,
		}
	}

	static send(jbSupply) {
		return {
			id: jbSupply.id,
			quantity: jbSupply.quantity,
			road_concept_jb: jbSupply.roadConceptJB,
      unit_measurement: 1,
			comment: jbSupply.comment,
			supply: jbSupply.supplyId,
		}
	}
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/services/roadConceptJBSupply.js